var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconJoomla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.11,16.65a7.79,7.79,0,0,0,2,7.76l7.83,7.83,3.48-3.48-7.84-7.83a2.9,2.9,0,0,1,4.1-4.09l.27.27,3.47-3.47-.27-.27a7.78,7.78,0,0,0-7.3-2.08,4.71,4.71,0,1,0-5.69,5.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.1,24.67l7.83-7.82A2.89,2.89,0,1,1,33,20.93l-.26.27,3.47,3.47.27-.27a7.8,7.8,0,0,0,2-7.68,4.71,4.71,0,1,0-5.29-5.32,7.79,7.79,0,0,0-7.72,2L17.63,21.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.56,33.14a7.81,7.81,0,0,0-2.07-7.37l-7.82-7.83-3.48,3.47L33,29.24a2.89,2.89,0,1,1-4.08,4.08l-.26-.26-3.48,3.47.27.27a7.83,7.83,0,0,0,7.82,1.94,4.71,4.71,0,1,0,5.28-5.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.45,25.5l-7.82,7.83a2.9,2.9,0,0,1-4.1-4.09L16.8,29,13.33,25.5l-.27.26a7.79,7.79,0,0,0-2,7.45,4.71,4.71,0,1,0,5.68,5.65,7.81,7.81,0,0,0,7.4-2.06L31.92,29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJoomla);
export default __webpack_public_path__ + "static/media/Icon-Joomla.a4388eeec0f8e004cbe4b56c3973e2a6.svg";
export { ForwardRef as ReactComponent };